import { Modal } from '@enterprise-ui/canvas-ui-react'
import { getOneDayInTheFuture } from '../services/helperFunctions'

export const FutureDateTimezoneMismatchExplanationModal = (props) => {
  const today = new Date()
  let tomorrow = getOneDayInTheFuture(today)

  return (
    <Modal headingText="Timezone Mismatch" {...props}>
      <div className="hc-pa-normal">
        {new Date(today.toLocaleDateString('en-US')) <
        new Date(today.toLocaleDateString('en-US', { timeZone: 'UTC' })) ? (
          <p>{`Dates are set in GMT. You are unable to select ${tomorrow.toLocaleDateString('en-US')} because it is currently ${today.toLocaleDateString('en-US', { timeZone: 'UTC' })} in GMT, therefore ${tomorrow.toLocaleDateString('en-US', { timeZone: 'UTC' })} is the earliest future date you can select.`}</p>
        ) : (
          <p>{`Dates are set in GMT. ${tomorrow.toLocaleDateString('en-US', { timeZone: 'UTC' })} is the earliest future date you can set because it is currently ${today.toLocaleDateString('en-US', { timeZone: 'UTC' })} in GMT, even though it is ${today.toLocaleDateString('en-US')} in your local timezone.`}</p>
        )}
      </div>
    </Modal>
  )
}
